import { ComponentType } from 'react';
import { Outlet } from 'react-router-dom';

import { TNavItemSize } from '@treezor/design-system';

import { ITab } from '@/store/models/profile.model';

import { NavigationTabs } from '@/ui-kit/navigation-tabs/NavigationTabs';

export const withTabs = (
  WrappedComponent: ComponentType<any>,
  routes: ITab[],
  options?: { size?: TNavItemSize; className?: string; contentClassName?: string },
) => (
  <WrappedComponent>
    <NavigationTabs items={routes} size={options?.size} className={options?.className} />
    <div className={options?.contentClassName}>
      <Outlet />
    </div>
  </WrappedComponent>
);
